var modules_127cd76a = {"panel":"_1i228fq","header":"_1dmgbis","collapse-icon":"_1y3g65m","active":"_1qfatd2","size-16":"_15qdta3","padding":"_2wjkfj","size-24":"_1e4sqj1","size-32":"_1pe1pjz","title":"_9c0a7d","subtitle":"_4oe6fb","icon":"_x6kh4","content":"_1d9ot6f","content-wrapper":"_11mknaa","separator-divider":"_14q3ogq","background-light":"_1iooj0q"};
import "../../../assets/nrZOSYrM.css";

export { modules_127cd76a as default };
//# sourceMappingURL=Accordion.module.less.js.map
